import { Button } from "@components/ui/button"
import { Link } from "react-router"

type TProspectLeftSectionProps = {
  prospect_guid: string
}

export const ProspectLeftSection = ({
  prospect_guid,
}: TProspectLeftSectionProps) => {
  return (
    <div className="tw:flex tw:flex-col tw:gap-2 tw:md:flex-row tw:md:items-center">
      <h2 className="tw:text-lg tw:font-black"> Sales Opportunities: </h2>
      <Button asChild>
        <Link to={`/prospect/${prospect_guid}/new_order`}>New Order</Link>
      </Button>
    </div>
  )
}
